import Joi from 'joi'

export const authorisationFormFields = {
  comment: 'comment',
}

export const authorisationFormSchema = Joi.object({
  comment: Joi.string().trim().max(1000).messages({
    'string.empty': 'This is a required field',
    'string.max': 'Comment must be 1000 characters or less',
  }),
})
